/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetCountryCodes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getCountryCodesRequest = createAction<PayloadData<void>>('GET_COUNTRY_CODES__GET_COUNTRY_CODES__REQUEST');
export const getCountryCodesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_COUNTRY_CODES__GET_COUNTRY_CODES__SUCCESS');
export const getCountryCodesFailure = createAction<PayloadData<Error, void, true>>('GET_COUNTRY_CODES__GET_COUNTRY_CODES__FAILURE');

export const getCountryCodesActions = [
    getCountryCodesRequest,
    getCountryCodesSuccess,
    getCountryCodesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getCountryCodes = (config?: GetCountryCodes$Config) => {
    return {
        CALL_API: {
            types: getCountryCodesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/country-type`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

